import clsx from "clsx";
import type { ComponentProps } from "react";

import { Section } from "@widgets/section";

import { ContactCard } from "@shared/ui/contact-card";
import { Container } from "@shared/ui/container";
import { Body, Heading } from "@shared/ui/typography";

import type { HelpItemType } from "@/_pages/medical-info/model";

import s from "./info-section.module.scss";

export type InfoSectionProps = ComponentProps<"div"> & {
  className?: string;
  title?: string;
  description?: string;
  items: HelpItemType[];
};

export const InfoSection = (props: InfoSectionProps) => {
  const { title, description, className, items } = props;

  return (
    <Section className={clsx(s.root, className)}>
      <Container className={s.inner}>
        <div className={s.col}>
          {title && (
            <Heading level={3} tag="h2">
              {title}
            </Heading>
          )}
          {description && <Body size="primary">{description}</Body>}
        </div>
        <div className={s.col}>
          {items?.length > 0 && (
            <div className={s.cards}>
              {items.map((item) => (
                <ContactCard
                  key={item.id}
                  title={item.title}
                  phone={item.phone}
                  icon={item.cardIcon}
                />
              ))}
            </div>
          )}
        </div>
      </Container>
    </Section>
  );
};

InfoSection.displayName = "InfoSection";
